var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-uploader",
      style: [{ "--height": _vm.height }, { "--width": _vm.width }]
    },
    [
      _c(
        "el-upload",
        {
          ref: "multipleUpload",
          attrs: {
            drag: "",
            multiple: _vm.multiple,
            action: _vm.path + "/fileUploadAndDownload/upload",
            headers: { "x-token": _vm.token },
            data: _vm.param,
            "before-upload": _vm.beforeImageUpload,
            "on-success": _vm.handleImageSuccess,
            "on-change": _vm.onChange,
            "on-remove": _vm.onRemove,
            "auto-upload": _vm.autoUpload,
            "file-list": _vm.fileArr,
            "show-file-list": false
          }
        },
        [
          _vm.multiple
            ? [
                _c("i", { staticClass: "el-icon-upload" }),
                _c("div", { staticClass: "el-upload__text" }, [
                  _vm._v("将文件拖到此处，或"),
                  _c("em", [_vm._v("点击上传")])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "el-upload__tip",
                    attrs: { slot: "tip" },
                    slot: "tip"
                  },
                  [_vm._v(_vm._s(_vm.tips))]
                )
              ]
            : [
                _vm.fileArr.length > 0 && _vm.fileArr[0].imgUrl
                  ? _c("img", {
                      staticClass: "bairun-upload-img-preview",
                      attrs: { src: _vm.fileArr[0].imgUrl, alt: "" }
                    })
                  : [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("将文件拖到此处，或"),
                        _c("em", [_vm._v("点击上传")])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [_vm._v(_vm._s(_vm.tips))]
                      )
                    ]
              ]
        ],
        2
      ),
      _c("div", [
        _c(
          "ul",
          { staticClass: "el-upload-list el-upload-list--text" },
          _vm._l(_vm.fileArr, function(item, index) {
            return _c(
              "li",
              {
                staticClass: "el-upload-list__item is-ready",
                attrs: { tabindex: "0" }
              },
              [
                _c("a", { staticClass: "el-upload-list__item-name" }, [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(
                    _vm._s(item.name) +
                      "（压缩后：" +
                      _vm._s((item.size / 1024).toFixed(0)) +
                      "KB）"
                  )
                ]),
                _vm._m(0, true),
                _c("i", {
                  staticClass: "el-icon-close",
                  on: {
                    click: function($event) {
                      return _vm.onDelImg(index)
                    }
                  }
                })
              ]
            )
          }),
          0
        )
      ]),
      _vm.multiple && _vm.fileArr.length > 0
        ? _c(
            "div",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitUpload } },
                [_vm._v("开始上传")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "el-upload-list__item-status-label" }, [
      _c("i", { staticClass: "el-icon-upload-success el-icon-circle-check" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }